import { NgModule } from '@angular/core';
import { NgbitPrettyFileInputComponent } from './ngbit-pretty-file-input.component';

@NgModule({
    imports: [],
    declarations: [NgbitPrettyFileInputComponent],
    exports: [NgbitPrettyFileInputComponent]
})
export class NgbitPrettyFileInputModule { }
